export default "__VITE_ASSET__BUFjQlOV__"